module.exports = __webpack_public_path__ + "static/img/gg.27c2bd2c.png";